import request from '@/utils/request'
// 商品列表
export function productList(params) {
  return request({
    url: '/product/list',
    method: 'get',
    params: params
  })
}
// 商品详情
export function productInfo(id) {
  return request({
    url: '/product/info/' + id,
    method: 'get'
  })
}
// 商品SKU详情
export function productSkuInfo(id, params) {
  return request({
    url: '/product/info/' + id,
    method: 'get',
    params: params
  })
}
// 商品评价
export function productCommentList(params) {
  return request({
    url: '/product/comment/list',
    method: 'get',
    params: params
  })
}
// 商品评价-单商品
export function productCommentInfo(id, params) {
  return request({
    url: '/product/comment/' + id,
    method: 'post',
    params: params
  })
}
// 商品收藏
export function productCollectionAdd(id) {
  return request({
    url: '/product/collection/add?productId=' + id,
    method: 'post'
  })
}
// 商品取消收藏
export function productCollectionDel(id) {
  return request({
    url: '/product/collection/delete?productId=' + id,
    method: 'post'
  })
}